// Coarse "N days ago" relative time for list rows. Day-granularity is
// deliberate — these surfaces show when something was connected/added,
// not a live clock. Pair it with a title={absolute} for the exact value.
export function relativeTime(iso: string): string {
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`;
  const years = Math.floor(days / 365);
  return `${years} year${years === 1 ? "" : "s"} ago`;
}

// Whole-day countdown for a display-only trial banner ("N days left").
// Moved from Billing.tsx (workstream C3) so BillingBanner and Billing
// render identical trial-countdown copy.
export function daysLeft(iso: string): number {
  return Math.max(
    0,
    Math.ceil((new Date(iso).getTime() - Date.now()) / 86_400_000),
  );
}
